import { useState } from "react";
import { SEARCH_QUERY_TOOL_RESULT_ROUTE } from "../../dashboard-routes";
import { DASHBOARD_ROUTE } from "../../../../routes";

const SearchQueryTool = ({ history }) => {
    const [queryString, setQueryString] = useState("");

    async function handleSubmit(e) {
        e.preventDefault();
        if (!queryString) return;

        history.push({
            pathname: DASHBOARD_ROUTE + SEARCH_QUERY_TOOL_RESULT_ROUTE,
            search: `?search=${queryString}`,
        });
    }

    return (
        <div id="search-query-tool">
            <div className="container-fluid p-0 px-0">
                <div className="card p-4 m-0 no-radius border-0 border-bottom">
                    <h5 className="card-title">Search Query Tool</h5>
                    <form onSubmit={handleSubmit}>
                        <div className="d-flex align-items-center justify-content-center px-5 mt-4">
                            <span className="text-nowrap me-4 text-2">Search Property for: </span>
                            <div className="input-group" style={{ maxWidth: "32rem" }}>
                                <input
                                    value={queryString}
                                    onChange={(e) => setQueryString(e.target.value)}
                                    type="text"
                                    className="form-control"
                                    placeholder="eg. John Smith"
                                    aria-label="Search Field"
                                    aria-describedby="basic-addon2"
                                    required
                                />

                                <button className="btn btn-primary text-white">Search</button>
                            </div>
                        </div>
                    </form>
                </div>

                {/* Search Hints Card */}

                <div className="card p-4 m-4 text-2">
                    <b>Search on any/ combinations:</b>
                    <ul className="mt-2">
                        <li>License Name</li>
                        <li>License Number</li>
                        <li>Trading Name</li>
                        <li>ABN/ACN</li>
                    </ul>
                </div>

                <div className="card p-4 m-4  text-3">
                    <p>
                        The information contained in this search is restricted to information which NSW Fair Trading is
                        required to maintain under the Property and Stock Agents Act 2002 from 1 September, 2003
                        onwards.
                    </p>
                    <p>
                        iComply Disclaims all responsibility and Liability (including without limitation, liability in
                        negligence) for all expenses, losses, damages and costs which you might incur as a result of the
                        information being inaccurate in any way, and for any reason.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SearchQueryTool;
